import * as actionTypes from "../actions/actionTypes";
import commonConfig from "../../components/commonConfig.json";

let customTabView = commonConfig.customTabView;

const initialState = {
  error: null,
  loading: false,
  userHotelsData: [],
  userHmgData: undefined,
  userHotelsReportsData: [],
  streamReportsData: [],
  qmsFilteredReportsData: [],
  complianceTableData: {},
  // complianceTableData: [],
  // customTabViewComplianceTableData: [],
  userHotelList: [],
  holisticHotelData: {},
  appConfigData: {},
  excelExportData: [],
  complianceReportsCategoriesData: {
    hotelsReportsMappedCategories: [],
    hotelsCategoriesMappedReports: [],
    // noCategoryReports: false,
    // reportsExist: false,
  },
};

export const qmsApi = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_APP_CONFIG_DATA_SUCCESS:
      return {
        ...state,
        appConfigData: action.data,
        error: null,
        loading: false,
      };
    case actionTypes.GET_HOLISTIC_DATA_SUCCESS:
      return {
        ...state,
        holisticHotelData: action.data,
        error: null,
        loading: false,
      };
    case actionTypes.GET_USER_LIST_SUCCESS:
      return {
        ...state,
        userHotelList: action.data,
        error: null,
        loading: false,
      };

    case actionTypes.GET_COMPLIANCE_TABLE_DATA_ERROR:
      // if (action.data.tabType === customTabView.CUSTOM)
      //   return {
      //     ...state,
      //     // customTabViewComplianceTableData: action.data.status,
      //     error: null,
      //     loading: false,
      //   };
      // else
      let copyOfTableDataErr = { ...state.complianceTableData };
      copyOfTableDataErr[action.data.tabType] = action.data.status;
        return {
          ...state,
          complianceTableData: copyOfTableDataErr,
          // complianceTableData: action.data.status,
          error: null,
          loading: false,
        };

    case actionTypes.GET_COMPLIANCE_TABLE_DATA_SUCCESS:
      // if (action.data.tabType === customTabView.CUSTOM)
        // return {
        //   ...state,
        //   customTabViewComplianceTableData: action.data.status,
        //   error: null,
        //   loading: false,
        // };
      // else
      let copyOfTableDataSucc = { ...state.complianceTableData };
      copyOfTableDataSucc[action.data.tabType] = action.data.status;
        return {
          ...state,
          complianceTableData: copyOfTableDataSucc,
          // complianceTableData: action.data.status,
          error: null,
          loading: false,
        };

    case actionTypes.GET_QMS_STAGE03_DUMMY_DATA:
      return {
        ...state,
        qmsStage03DummyData: action.data,
        error: null,
        loading: false,
      };
    case actionTypes.GET_USER_HMG_DATA_SUCCESS:
      return {
        ...state,
        userHmgData: action.data,
        error: null,
        loading: false,
      };
    case actionTypes.GET_USER_HOTELS_SUCCESS:
      return {
        ...state,
        userHotelsData: action.data,
        error: null,
        loading: false,
      };
    case actionTypes.GET_USER_HOTELS_REPORTS_SUCCESS:
      return {
        ...state,
        userHotelsReportsData: action.data,
        error: null,
        loading: false,
      };
    case actionTypes.GET_FILTRD_QMS_REPORTS_SUCCESS:
      return {
        ...state,
        qmsFilteredReportsData: action.data,
        error: null,
        loading: false,
      };
    case actionTypes.STRM_REPORT_DATA_APPLY_SUCCESS:
      return {
        ...state,
        streamReportsData: action.data,
        error: null,
        loading: false,
      };
    case actionTypes.GET_EXCEL_EXPORT_DATA_SUCCESS:
      return {
        ...state,
        excelExportData: action.data,
        error: null,
        loading: false,
      };
    case actionTypes.GET_COMP_REPORT_CAT_SUCCESS:
      return {
        ...state,
        complianceReportsCategoriesData: action.data,
        error: null,
        loading: true,
      };
    case actionTypes.GET_COMP_REPORT_CAT_FAIL:
      return {
        ...state,
        complianceReportsCategoriesData: action.data,
        error: null,
        loading: false,
      };
    default:
      return state;
  }
};

export default qmsApi;
